import styled from 'styled-components'
import { Link } from 'react-router-dom';

const buttonScale = 0.85
const buttonWidth = 295
const buttonHeight = 45

export const ButtonBackground = styled.div`
  position: absolute;
  width: ${buttonWidth / buttonScale}px;
  height: ${buttonHeight}px;
  top: 0;
  left: 0;

  color: #e6f2fe;
  background: rgba(5, 75, 130, .7);
  z-index: 1;
  clip-path: polygon(2% 0, 100% 12%, 99% 87%, 0 97%);
  transform: scaleX(0.85);

  @media screen and (max-width: 812px) {
    height: 35px;
    transform-origin: 0;
  }
`

export const Button = styled(Link)`
  position: absolute;
  top: ${ props => props.selected ? '-5px' : '0' };
  left: ${ props => props.selected ? '5px' : '0' };
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  width: ${buttonWidth / buttonScale}px;
  height: ${buttonHeight}px;

  text-decoration: none;
  font-family: 'Crash';
  font-size: 1.65em;
  transform: scaleX(0.85);
  color: ${ props => props.selected ? "#054b82" : "#60b2e1" };
  background: ${ props => props.selected ? "rgba(219, 239, 245, 1)" : "" };
  z-index: ${ props => props.selected ? 3 : 1 };
  clip-path: ${ props => props.selected ? 'polygon(2% 0, 100% 12%, 99% 82%, 0 100%)' : 'polygon(2% 0, 100% 12%, 99% 87%, 0 97%)' };
  transition: 0.1s;

  @media screen and (max-width: 812px) {
    height: 35px;
    font-size: 1.35em;
    transform-origin: 0;
  }
`

export const Container = styled.div`
  position: relative;
  margin: 0.1em;
  width: ${buttonWidth}px;
  height: ${buttonHeight + 5}px;

  &:hover ${Button}{
    top: -3px;
    left: 3px;
    color: #054b82;
    background: rgba(219, 239, 245, 1);
    /* clip-path: polygon(2% 0, 100% 12%, 99% 82%, 0 100%); */
    z-index: 3;
    transition: 0.1s;
  }

  @media screen and (max-width: 812px) {
    height: 50%;
  }
`